export default class ResourceTimelineHeader {
  eGui;

  init(params) {
    this.eGui = document.createElement('div');
    this.eGui.classList.add('custom-header');
    let stringDate='';

    //this is used for a timesheets use case
    if(params.displayName !== "Hours" && params.displayName !== "Business Object Key"){
      stringDate = params.displayName
    }
    else{
      stringDate = params.column.colDef.pivotKeys[0]
    }
    const day = new Date(stringDate).toLocaleString(undefined, {
      weekday: 'short',
    });
    const date = new Date(stringDate).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
    });

    var dayOfWeek = new Date(stringDate).getDay();
    if((dayOfWeek === 6) || (dayOfWeek  === 0)){
      params.eGridHeader.style.backgroundColor = 'rgba(0,0,0,0.03)'
    }

   
    this.eGui.innerHTML = `
          <div class="header-group">
          <div class="title">${day}</div>
          <div class="sub-title">${date}</div>
          </div>`;
  }

  getGui() {
    return this.eGui;
  }

  refresh() {
    return false;
  }
}
